module.exports = __webpack_public_path__ + "src/img/sketchrunner/laptop.1309c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sketchrunner/laptop.jpg
// module id = 256
// module chunks = 0